import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Card, Col, Row, Button, Space } from "antd";
import { observer } from "mobx-react-lite";
import styles from "@/styles/Filters.module.less";
/**
 * Generic Filters Component
 * Following the architecture requirements:
 * - Functional React component that accepts FiltersStore
 * - Renders items using items.map(({Cmp, props}) => <Cmp {...props}/>)
 * - No switch statements
 * - Configurable and extensible
 */
const Filters = observer(({ filtersStore, className, title = "Фильтры", showClearAll = true, showApplyButton = false, onApply, gridConfig = { xs: 24, sm: 12, md: 8, lg: 6, xl: 6 }, }) => {
    const visibleItems = filtersStore.getVisibleItems();
    const hasActiveFilters = filtersStore.hasActiveFilters();
    const activeFilterCount = filtersStore.getActiveFilterCount();
    const handleClearAll = () => {
        filtersStore.clearAllFilters();
    };
    const handleApply = () => {
        if (onApply) {
            onApply();
        }
    };
    if (visibleItems.length === 0) {
        return null;
    }
    return (_jsx(Card, { className: `${styles.filtersCard} ${className || ""}`, children: _jsxs("div", { className: styles.filtersContainer, children: [_jsx("div", { className: styles.filtersHeader, children: _jsxs("span", { className: styles.filtersTitle, children: [title, hasActiveFilters && (_jsxs("span", { className: styles.activeFiltersCount, children: ["(", activeFilterCount, ")"] }))] }) }), _jsx(Row, { gutter: [16, 16], children: visibleItems.map((item) => {
                        const { Cmp, props } = item;
                        return (_jsx(Col, { ...gridConfig, children: _jsx("div", { className: styles.filterItem, children: _jsx(Cmp, { ...props, value: filtersStore.values[props.name] }) }) }, item.id));
                    }) }), (hasActiveFilters || showApplyButton) && (_jsx(Row, { gutter: [16, 16], style: { marginTop: 16 }, children: _jsx(Col, { xs: 24, children: _jsx("div", { className: styles.filterActions, children: _jsxs(Space, { children: [showClearAll && hasActiveFilters && (_jsx(Button, { onClick: handleClearAll, children: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u044B" })), showApplyButton && (_jsx(Button, { type: "primary", onClick: handleApply, children: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C" }))] }) }) }) })), filtersStore.isLoading && (_jsx("div", { className: styles.loadingOverlay, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432..." })), filtersStore.error && (_jsxs("div", { className: styles.errorMessage, children: ["\u041E\u0448\u0438\u0431\u043A\u0430: ", filtersStore.error] }))] }) }));
});
Filters.displayName = "Filters";
export default Filters;
